export default __webpack_public_path__ + "static/media/circleOnTopRight.a7520c93.svg";